import { toast } from "react-toastify";
import { getErrorMessage } from "../utils/commonUtils";
import { useCreateCustomFieldsMetadataMutation, useGetAllCustomFieldsValuesMutation,
   useGetCustomFieldsControlTypeMutation,
   useGetCustomFieldsDataTypeMutation,
   useGetCustomFieldsMetadataMutation, 
   useGetCustomFieldsModuleMutation
  } from "../redux/customFields/customFieldsApiSlice";

export default function useCustomFields() {
  const [getAllCustomFieldsValues, { isLoading: getAllCustomFieldsValuesLoading }] =
    useGetAllCustomFieldsValuesMutation();
  const [getCustomFieldsMetadata,{isLoading:getCustomFieldsMetadataLoading}] =
    useGetCustomFieldsMetadataMutation();
  const [getCustomFieldsControlType,{isLoading:getCustomFieldsControlTypeLoading}] = 
    useGetCustomFieldsControlTypeMutation();
  const [getCustomFieldsDataType,{isLoading:getCustomFieldsDataTypeLoading}] = 
    useGetCustomFieldsDataTypeMutation();
  const  [getCustomFieldsModule,{isLoading:getCustomFieldsModuleLoading}] = 
  useGetCustomFieldsModuleMutation();
  const [createCustomFieldsMetadata, {isLoading:createCustomFieldsMetadataLoading}] =
  useCreateCustomFieldsMetadataMutation();

 const getCustomFieldsMetadataAPI = async ({}) => {
    try {
      const response = await getCustomFieldsMetadata({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getAlCustomFieldsValuesAPI = async ({}) => {
    try {
      const response = await getAllCustomFieldsValues({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsControlTypeAPI = async ({}) => {
    try {
      const response = await getCustomFieldsControlType({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsDataTypeAPI = async ({}) => {
    try {
      const response = await getCustomFieldsDataType({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const getCustomFieldsModuleAPI = async ({}) => {
    try {
      const response = await getCustomFieldsModule({}).unwrap();
      return response.result;
    } catch (err: any) {
      const message = getErrorMessage(err);
      throw new Error(message);
    }
  };
  const createCustomFieldsMetadataAPI = async (data: any) => {
      try {
        const response: any = await createCustomFieldsMetadata(data).unwrap();
        toast.success("Success! Custom Field has been Created.");
        return response.result;
      } catch (err: any) {
        const message = getErrorMessage(err);
        throw new Error(message);
      }
    };
  
  return {
    getCustomFieldsMetadataAPI,
    getCustomFieldsMetadataLoading,
    getAlCustomFieldsValuesAPI,
    getAllCustomFieldsValuesLoading,
    getCustomFieldsControlTypeAPI,
    getCustomFieldsControlTypeLoading,
    getCustomFieldsDataTypeAPI,
    getCustomFieldsDataTypeLoading,
    getCustomFieldsModuleAPI,
    getCustomFieldsModuleLoading,
    createCustomFieldsMetadataAPI,
    createCustomFieldsMetadataLoading
  };
}